import { getUniqueCategoriesFromShops } from "../modules/getUniqueCategoriesFromShops";
// import qs from "qs";

// const options = qs.parse(window.location.search.slice(1));

const initialState = {
  activeFeatureName: "2000",
  hoveredFeature: undefined,
  searchBarVisible: false,
  searchedLocation: null, //Don't need this. (No address search)
  activePage: "map", // Not relevant? There was a table view before.
  activeFilters: [], // E.g. food, wine, etc.
  allFilters: [],
  basemap: "ROADMAP",
  activeProject: undefined, // This will be activeBusiness. And instead of popup, we have sidebar
  viewingHub: undefined, //Not used!
  mapType: "postcodeNsw", // affects geometryconfig
  internal: true,
  zoomToNsw: Date.now(), // hack that lets you zoom to NSW based on state
  sidebarScrollup: Date.now(),
  sidebarIsOpen: true,
  numFilters: 0,
  activeDataset: "occupations"
};
export default (state = initialState, action) => {
  switch (action.type) {
    case "ACTIVE_FEATURE:SET":
      return {
        ...state,
        searchedLocation: null,
        activeFeatureName: action.payload,
      };
    case "DATASET:SET":
      return {
        ...state, activeDataset: action.payload,
      }
    case "HOVERED_FEATURE:SET":
      return {
        ...state,
        hoveredFeature: action.payload,
      };
    case "FILTERS:SET_INITIAL":
      const uniqFilters = getUniqueCategoriesFromShops(action.payload);
      return {
        ...state,
        activeFilters: uniqFilters,
        allFilters: uniqFilters,
        numFilters: uniqFilters.length,
      };
    case "SEARCH_BAR_VISIBLE:SET":
      return { ...state, searchBarVisible: action.payload };
    case "SEARCHED_LOCATION:SET":
      return { ...state, searchedLocation: action.payload };
    case "ACTIVE_PROJECT:SET":
      return { ...state, activeProject: action.payload };
    case "ACTIVE_FILTER:SET_ALL": {
      return { ...state, activeFilters: [...state.allFilters] };
    }
    case "ACTIVE_FILTER:SET": {
      const { activeFilters } = state;
      let newFilters = [];
      // If all filters are selected, then select only the clicked one
      if (activeFilters.length === state.numFilters) {
        newFilters = activeFilters.filter(d => d === action.payload);
        // Else unselect if it's selected
      } else if (activeFilters.includes(action.payload)) {
        newFilters = activeFilters.filter(d => d !== action.payload);
        // Or select if it's not
      } else {
        newFilters = activeFilters.concat(action.payload);
      }
      return { ...state, activeFilters: newFilters };
    }
    case "ACTIVE_PAGE:SET": {
      return { ...state, activePage: action.payload };
    }
    case "MAP_TYPE:SET": {
      return { ...state, mapType: action.payload };
    }
    case "MAP:SET_BASEMAP": {
      return { ...state, basemap: action.payload };
    }
    case "ZOOM_TO_NSW": {
      // return state;
      return { ...state, zoomToNsw: action.payload };
    }
    case "SIDEBAR:OPEN": {
      return { ...state, sidebarIsOpen: action.payload };
    }
    case "SIDEBAR:SCROLLUP": {
      return { ...state, sidebarScrollup: action.payload };
    }

    default:
      return state;
  }
};

export const selectActiveFeatureName = s => s.activeFeatureName;
export const selectActiveDataset = s => s.activeDataset;
export const selectHoveredFeature = s => s.hoveredFeature;
export const selectSearchBarVisible = s => s.searchBarVisible;
export const selectSearchedLocation = s => s.searchedLocation;
export const selectActiveProject = s => s.activeProject;
export const selectActiveFilters = s => s.activeFilters;
export const selectActivePage = s => s.activePage;
export const selectMapType = s => s.mapType;
export const selectViewingHub = s => s.viewingHub;
export const selectIsInternal = s => s.internal;
export const selectBasemap = s => s.basemap;
export const selectZoomToNsw = s => s.zoomToNsw;
export const selectSidebarIsOpen = s => s.sidebarIsOpen;
export const selectSidebarScrollup = s => s.sidebarScrollup;



// WEBPACK FOOTER //
// ./src/reducers/ui.js